export default {
  items: {
    all: {
      home: "Hjem"
    },
    artist: {
      subheader: "Administrer",
      tracks: "Låter",
      orders: "Bestillinger"
    },
    customer: {}
  }
}



// WEBPACK FOOTER //
// ./src/locales/no/layout/navigation/sidebar.js